export default {
  name: 'Data Archiving',
  title: 'Data Archiving',
  subtitle: 'Data as of %{responseTime}',
  error: 'Could not load the archive overview.',
  periodValue: '%{from} – %{to}',
  tabs: {
    tables: 'Tables',
    partitions: 'Partitions',
  },
  summary: {
    title: 'Summary',
    archiving: 'Archiving',
    archived: 'Archived',
    inProgress: 'In progress',
    needsAttention: 'Needs attention',
    partitions: '%{count} partition |||| %{count} partitions',
    rows: '%{count} row |||| %{count} rows',
    archivedValue: '%{partitions} · %{rows} · %{size}',
    needsAttentionValue: '%{partitions} · %{services}',
    servicesUnavailable:
      '%{smart_count} service unavailable |||| %{smart_count} services unavailable',
    reasonOfServices: '%{reason} (%{services})',
    services: '(%{services})',
  },
  alerts: {
    RETAINED_NO_STORAGE:
      '%{count} expired partition of %{table} is kept in the database: %{reason}. |||| %{count} expired partitions of %{table} are kept in the database: %{reason}.',
    ARCHIVE_FAILED:
      '%{count} partition of %{table} failed to archive. |||| %{count} partitions of %{table} failed to archive.',
    SERVICE_UNAVAILABLE: 'Service %{service} is unavailable: its tables are not shown (%{reason}).',
    viewPartitions: 'View partitions',
    viewFailed: 'View failed',
  },
  tables: {
    table: 'Table',
    retention: 'Retention',
    policy: 'Policy',
    archiving: 'Archiving',
    coverage: 'Coverage',
    period: 'Period',
    archivedRows: 'Archived Rows',
    archivedSize: 'Archived Size',
    coverageCount: ': %{count}',
    empty: 'No partitioned tables',
    policies: {
      ARCHIVE: 'Archive',
      DROP: 'Delete',
    },
  },
  list: {
    filters: {
      table: 'Table',
      status: 'Status',
    },
    empty: 'No partitions found',
    noTable: 'Select a table to see its partitions.',
    restoreNote:
      'Archived partitions are restored by operations from the archive object (Object Key); there is no restore from the Dashboard.',
    partition: 'Partition',
    period: 'Period',
    status: 'Status',
    attached: 'Attached',
    rows: 'Rows',
    size: 'Size',
    attempts: 'Attempts',
    objectKey: 'Object Key',
    objectLocation: 'Object Location',
    sha256: 'SHA-256',
    lastError: 'Last Error',
    enqueuedAt: 'Enqueued At',
    updatedAt: 'Updated At',
  },
  byteUnits: {
    B: 'B',
    KB: 'KB',
    MB: 'MB',
    GB: 'GB',
    TB: 'TB',
  },
};
